export default {"src":"/uk/_next/static/media/down-filled.e7b875a1.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};